import { useState, useEffect } from 'react';
import { onAuthStateChanged, getIdToken } from 'firebase/auth';
import { auth } from '../firebase';

const useFirebaseAuthReady = () => {
  const [isAuthReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await getIdToken(user);
        localStorage.setItem('token', token);
      }
      setAuthReady(true);
    });

    return () => unsubscribe();
  }, []);

  return isAuthReady;
};

export default useFirebaseAuthReady;
